import React from "react"
import SubsectionContainer from "../shared/SubsectionContainer"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import RowContainer from "../../shared/components/Layout/RowContainer"
import { Typography, typographyTypes } from "../../shared/components/Typography"
import Icon from "../../shared/components/Icon"

export enum NewPatientStatusEnum {
  ACCEPTING = "accepting",
  NOT_ACCEPTING = "not-accepting",
  ACCEPTING_WITH_WAITLIST = "accepting-with-waitlist",
}

interface NewPatientStatusProps {
  acceptingNewPatientsStatus: NewPatientStatusEnum
}

export const NewPatientStatus: React.FC<NewPatientStatusProps> = ({
  acceptingNewPatientsStatus,
}) => {
  const { cms: cmsContent } = useCMSReady(["publicProfileSlide"])
  const publicProfileText = cmsContent.publicProfileSlide

  const ADD_USER = "addUser"

  const accpetingNewPatientsTextMap: Record<NewPatientStatusEnum, string> = {
    [NewPatientStatusEnum.ACCEPTING]:
      publicProfileText?.atAGlanceSubsectionAcceptingPatientsText || "",
    [NewPatientStatusEnum.NOT_ACCEPTING]:
      publicProfileText?.atAGlanceSubsectionNoNewPatientsText || "",
    [NewPatientStatusEnum.ACCEPTING_WITH_WAITLIST]:
      publicProfileText?.atAGlanceSubsectionPatientWaitlistText || "",
  }

  return (
    <SubsectionContainer>
      <RowContainer styleOverrides="space-x-2">
        <Icon iconType={ADD_USER} />
        <Typography
          text={accpetingNewPatientsTextMap[acceptingNewPatientsStatus]}
          variant={typographyTypes.NORMAL}
        />
      </RowContainer>
    </SubsectionContainer>
  )
}
